import { render, staticRenderFns } from "./FilterHosp.vue?vue&type=template&id=6056ce46"
import script from "./FilterHosp.vue?vue&type=script&lang=js"
export * from "./FilterHosp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports